import ReactTooltip from "react-tooltip";
import { TooltipStyled, TooltipButton } from "./Tooltip.styled";

export default function Tooltip() {
    return (
        <TooltipStyled>
            <TooltipButton
                data-tip="Let op! Besteding op deze dag kan niet gegarandeerd worden. Op deze dag vervalt je kaart. Besteed jouw kaart daarom voor deze datum om teleurstelling te voorkomen."
                data-event="click focus"
            >
                <img
                    src="/images/icon-info.svg"
                    alt=""
                    width="20"
                    height="20"
                    loading="lazy"
                />
            </TooltipButton>
            <ReactTooltip
                place="top"
                effect="solid"
                globalEventOff="click"
                className="tooltip"
            />
        </TooltipStyled>
    );
}
